export default __webpack_public_path__ + "static/media/Q1_4_resized.58d04226.jpg";